/* KLIK WhatsApp handoffs (v2 · bugs-nav, K-106, K-018).
   1. window.KlikWhatsApp = {number, message, build(ctx), open(ctx)} — the ONE message builder (PACKAGES §3.1) — is defined
      inline in snippets/klik-whatsapp.liquid, BEFORE the bubble, as a real window property. The bubble keeps
      id="KlikWhatsApp" (other packages' CSS and klik-product-dock.js / klik-decision-studio.js select it), and a real
      property always wins over named element access, so window.KlikWhatsApp is never the <a> element.
   2. Every click on a wa.me link to KLIK publishes `klik_whatsapp_opened` through Shopify.analytics.publish.
   3. Existing product links keep the shopper's ready-to-ship selection (enrich), as before. No requests. */
(() => {
  'use strict';
  const NUMBER = '966503889913';
  const allowedHosts = new Set(['klikdecor.com', 'ar.klikdecor.com']);
  const safe = (value, max = 120) => String(value || '').replace(/[\r\t{}]/g, ' ').replace(/[  ]+/g, ' ').trim().slice(0, max);
  /* Keeps a product link's ready-to-ship selection (unchanged behaviour). */
  function enrich(href, pageHref, selection = {}, context = '', arabic = false) {
    try {
      const wa = new URL(href), page = new URL(pageHref);
      if (wa.protocol !== 'https:' || wa.hostname !== 'wa.me' || wa.pathname !== '/' + NUMBER) return href;
      if (page.protocol !== 'https:' || !allowedHosts.has(page.hostname) || !/^\/products\/[^/]+\/?$/.test(page.pathname) || page.searchParams.has('request')) return href;
      const text = wa.searchParams.get('text');
      if (!text || text.length > 1800) return href;
      let matched = false, privateLink = false;
      const variant = /^\d{8,20}$/.test(String(selection.variant || '')) ? String(selection.variant) : page.searchParams.get('variant');
      const updated = text.replace(/https:\/\/[^\s]+/g, raw => {
        try {
          const link = new URL(raw);
          if (!allowedHosts.has(link.hostname) || link.pathname !== page.pathname) return raw;
          // Saved designs and signed request links already have their own handoff.
          if (link.hash || [...link.searchParams.keys()].some(k => k !== 'variant')) { privateLink = true; return raw; }
          matched = true;
          const clean = new URL(page.origin + page.pathname);
          if (/^\d{8,20}$/.test(variant || '')) clean.searchParams.set('variant', variant);
          return clean.href;
        } catch (_) { return raw; }
      });
      if (!matched || privateLink) return href;
      const details = [];
      if (selection.label) details.push((arabic ? 'الاختيار الحالي: ' : 'Current selection: ') + safe(selection.label));
      if (Number.isInteger(selection.quantity) && selection.quantity >= 1 && selection.quantity <= 6) details.push((arabic ? 'الكمية: ' : 'Quantity: ') + selection.quantity);
      if (selection.fabric) details.push((arabic ? 'القماش المعروض: ' : 'Displayed fabric: ') + safe(selection.fabric));
      // The existing consent-aware helper returns public campaign/ad IDs only.
      if (/^Campaign reference: \d{12,22}( \/ Ad: \d{12,22})?$/.test(context)) details.push(context);
      wa.searchParams.set('text', updated + (details.length ? '\n\n' + details.join('\n') : ''));
      return wa.href;
    } catch (_) { return href; }
  }
  if (typeof module === 'object' && module.exports) { module.exports = { build: enrich, enrich }; return; }

  const publish = (name, payload) => { try { window.Shopify?.analytics?.publish?.(name, payload); } catch (_) {} };
  /* One event for every WhatsApp handoff, whoever built the link. */
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href^="https://wa.me/' + NUMBER + '"]');
    if (!link) return;
    const topic = link.dataset.klikWaTopic || (link.closest('.kf7') ? 'footer' : link.closest('[data-ready-configurator],[data-klik-dpo-wizard],[data-furniture-configurator]') ? 'studio' : document.body.classList.contains('template-cart') ? 'cart' : 'page');
    publish('klik_whatsapp_opened', {
      topic,
      productId: link.dataset.klikWaProduct || window.ShopifyAnalytics?.meta?.product?.id || null,
      handle: link.dataset.klikWaHandle || null,
      placement: link.id === 'KlikWhatsApp' ? 'bubble' : (link.className || '').toString().split(' ')[0] || 'link',
      lang: document.documentElement.lang || ''
    });
  }, true);

  const originals = new WeakMap();
  function selection() {
    const dialogs = [...document.querySelectorAll('[data-ready-configurator]')];
    const node = dialogs.find(n => {
      try { return new URL(n.dataset.productUrl, location.origin).pathname === location.pathname; } catch (_) { return false; }
    });
    if (!node) return {};
    const chosen = node.querySelector('[data-ready-variant][aria-pressed="true"]');
    const fabric = node.querySelector('[data-ready-fabric][aria-pressed="true"]');
    const quantity = node.querySelector('[data-ready-quantity]');
    return { variant: chosen?.dataset.readyVariant, label: chosen?.querySelector('strong')?.textContent,
      quantity: quantity ? Number(quantity.value) : undefined, fabric: fabric?.getAttribute('aria-label') };
  }
  function enhance(anchor) {
    if (!anchor || !/^https:\/\/wa\.me\//.test(anchor.href || '') || anchor.closest('#klik-custom-design,[data-ready-configurator],[data-klik-dpo-wizard]') || anchor.matches('[data-project-whatsapp]')) return;
    const saved = originals.get(anchor), current = anchor.href;
    const original = saved && current === saved.generated ? saved.original : current;
    const result = enrich(original, location.href, selection(), window.KlikJourney?.contextSummary?.() || '', /^ar/i.test(document.documentElement.lang || ''));
    if (result !== current) anchor.href = result;
    originals.set(anchor, { original, generated: result });
  }
  function all() { document.querySelectorAll('a[href^="https://wa.me/' + NUMBER + '"]').forEach(enhance); }
  for (const name of ['pointerover', 'focusin', 'click', 'auxclick']) document.addEventListener(name, event => enhance(event.target.closest?.('a[href]')));
  let scheduled = false;
  document.addEventListener('click', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; all(); }); } });
  document.addEventListener('visitorConsentCollected', all);
  document.addEventListener('shopify:section:load', all);
  window.addEventListener('pageshow', all);
  all();
})();
